import { createRootRoute, Outlet } from "@tanstack/react-router";
import { OpenedViewsContextProvider } from "src/routing/keepAlive/OpenedViewsContextProvider.tsx";
import { AavoToastContextProvider } from "src/components/common/toast/AavoToastContextProvider.tsx";

export const Route = createRootRoute({
	component: RootComponent,
});

function RootComponent() {
	return (
		<OpenedViewsContextProvider>
			<AavoToastContextProvider>
				<Outlet />
			</AavoToastContextProvider>
		</OpenedViewsContextProvider>
	);
}
